/**
 * Auth Form Schemas med Zod
 * Validering för login, signup, etc.
 */

import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createLoginFormSchema(t: TFunction) {
  return z.object({
    email: z
      .string()
      .min(1, t('copy.admin.emailRequired'))
      .email(t('copy.admin.invalidEmail')),
    password: z.string().optional(),
  });
}

export type LoginFormData = z.infer<ReturnType<typeof createLoginFormSchema>>;

export function createSignUpFormSchema(t: TFunction) {
  return z
    .object({
      first_name: z.string().trim().min(2, t('copy.admin.firstNameMin')),
      last_name: z.string().trim().min(2, t('copy.admin.lastNameMin')),
      email: z.string().trim().email(t('copy.admin.invalidEmail')),
      password: z
        .string()
        .min(8, t('copy.admin.passwordMin'))
        .regex(/[A-Z]/, t('copy.admin.passwordUpper'))
        .regex(/[a-z]/, t('copy.admin.passwordLower'))
        .regex(/\d/, t('copy.admin.passwordDigit'))
        .regex(/[^a-zA-Z\d]/, t('copy.admin.passwordSpecial')),
      confirmPassword: z.string(),
      tos_accept: z.boolean().refine((val) => val === true, {
        message: t('copy.admin.acceptTerms'),
      }),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('copy.admin.passwordsMismatch'),
      path: ['confirmPassword'],
    });
}

export type SignUpFormData = z.infer<ReturnType<typeof createSignUpFormSchema>>;
